import React, {useEffect, useState, useRef} from 'react';
import {connect} from 'react-redux';
import {Loader, Container} from 'semantic-ui-react';
import {Alert} from 'componentLibrary';
// import { datadogLogs } from '@datadog/browser-logs';
// import { datadogRum } from '@datadog/browser-rum'

export function DependencyAwareLoader(props) {
  const [isTriggered, setIsTriggered] = useState(false);
  const {
    numLoadedSuccessfully,
    allDependencies,
    failedDependencies,
    successfulDependencies,
  } = props;
  const missingDependencies = _.difference(allDependencies, successfulDependencies);

  // Starts the timer for slow-loading dependencies warning threshold
  useEffect(() => {
    const timer = setTimeout(() => {
      if (missingDependencies.length > 0) {
        window.DD_LOGS?.logger.warn(
          `Slow to load dependencies: ${missingDependencies.join(', ')}`
        );
      }
    }, 3000);
    return () => clearTimeout(timer);
  }, [failedDependencies, successfulDependencies]);

  // Starts the timer for slow-loading dependencies error threshold
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsTriggered(true);
      if (missingDependencies.length > 0) {
        window.DD_LOGS?.logger.error(
          `Missing dependencies after loading threshold reached: ${missingDependencies.join(
            ', '
          )}`
        );
      }
    }, 7000);
    return () => clearTimeout(timer);
  }, [failedDependencies, successfulDependencies]);

  return (
    <Container text>
      <div className="margin-top30">
        <Loader inline="centered" active size="small">
          Loading{' '}
          {numLoadedSuccessfully && allDependencies
            ? `${numLoadedSuccessfully}/${allDependencies.length}`
            : '...'}
        </Loader>

        {isTriggered && (
          <Alert type="error" header="Missing Dependencies">
            Some dependencies are taking longer than expected to load:
            <ul>
              {missingDependencies.map((d) => (
                <li key={`missingDependencyWarning${d}`}>{d}</li>
              ))}
            </ul>
            <small>{_.get(window.DD_LOGS?.getInternalContext(), 'session_id')}</small>
          </Alert>
        )}

        {failedDependencies && failedDependencies.length > 0 && (
          <Alert type="error" header="Failed Dependencies">
            Failed to load the following dependencies:
            <ul>
              {failedDependencies.map((d) => (
                <li key={`failedDependencyError${d}`}>{d}</li>
              ))}
            </ul>
            <small>{_.get(window.DD_LOGS?.getInternalContext(), 'session_id')}</small>
          </Alert>
        )}
      </div>
    </Container>
  );
}

export const mapStateToProps = (state) => {
  return {
    context: _.get(state, 'dynamicComponent.context'),
    numLoadedSuccessfully: _.get(state, 'dynamicComponent.context.numLoadedSuccessfully'),
    allDependencies: _.get(state, 'dynamicComponent.context.allDependencies', []),
    successfulDependencies: _.get(
      state,
      'dynamicComponent.context.successfulDependencies',
      []
    ),
    failedDependencies: _.get(state, 'dynamicComponent.context.failedDependencies', []),
  };
};

export default connect(mapStateToProps)(DependencyAwareLoader);
